import { render, staticRenderFns } from "./editInProject.vue?vue&type=template&id=24fb2366&"
import script from "./editInProject.vue?vue&type=script&lang=js&"
export * from "./editInProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports